import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

// 구역 구분
export const HeaderWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 10px 0 0 0;
  margin-bottom: 20px;
  background-color: white;
`;

export const StickyHeader = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  position: -webkit-sticky;
  position: sticky;
  top: 73px;
  z-index: 998;
  background-color: white;
  padding: 10px 110px;
  padding-left: 110px;
  border-bottom: 1px solid #ececec;
  & h2 {
    width: fit-content;
    cursor: pointer;
    margin-bottom: 20px;
    :hover {
      color: #198754;
    }
  }
`;

export const HeaderStepWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: baseline;
  /* margin-bottom: 10px; */
  padding: 0px 25px;
  & ul {
    display: flex;
  }
  & li {
    margin-right: 10px;
    font-size: 1.1rem;
    :last-of-type {
      margin-right: 0px;
    }
  }
`;

export const HeaderStep = styled.li`
  color: ${(props) => (props.active ? "#198754" : "#6c757d")};
  cursor: pointer;
  display: flex;
  align-items: center;

  :hover {
    color: #198754;
  }

  & i {
    margin-left: 10px;
    padding-top: 1px;
  }
`;

export const HeaderTitle = styled.h3`
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  margin: 0 auto 50px auto;
  width: fit-content;
  line-height: 1.5;
  word-break: keep-all;

  & strong {
    z-index: 2;
    font-weight: 700;
    border-bottom: 5px solid #3bb77e;
  }

  @media screen and (max-width: 991px) {
    font-size: 36px;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 767px) {
    font-size: 26px;
  }

  @media (max-width: 575px) {
    font-size: 22px;
    display: none;
  }
`;

export const TitleShadow = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
  opacity: 0.5;
  z-index: -1;
  background-color: #3bb77e;
`;

// body
export const Sidebar = styled.div`
  width: 20%;
  word-break: keep-all;
  margin-top: 0;

  .sidebar-widget {
    padding: 20px;
  }

  @media screen and (max-width: 350px) {
    width: 100%;
  }

  @media screen and (min-width: 351px) and (max-width: 991px) {
    width: 100%;
    & ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    & li {
      width: 48%;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1200px) {
    width: 30%;
  }

  @media screen and (max-width: 1200px) {
    .sidebar-widget {
      & h5 {
        font-size: 1.2rem;
      }
      & li {
        padding: 5px 0.5rem;
      }
    }
  }
`;

// 내용
export const StepContents = styled.div`
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  margin: 0 auto;
  /* overflow: hidden; */

  @media screen and (max-width: 991px) {
    width: 100%;
  }
`;

// 좌측 스텝 <-> categorysection
export const StepSection = styled.div`
  width: 100%;
  min-height: 40rem;
  display: flex;

  .side_step {
    display: none !important;
  }
  .m_sticky {
    display: none;
  }

  @media screen and (max-width: 991px) {
    flex-direction: column;
    .side_step {
      display: flex !important;
    }
  }
  @media screen and (max-width: 767px) {
    .m_sticky {
      display: flex;
    }
    .pc_sticky {
      display: none;
    }
  }
`;

export const StepWrapper = styled.div`
  width: 60px;
  min-height: 35rem;
  margin-right: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #3bb77e;
  border-radius: 50px;
  padding: 20px 10px;
  color: #fff;

  @media screen and (max-width: 991px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 1rem;
    margin-right: 0px;
    padding: 10px;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 767px) {
    padding: 5px 10px;
  }

  .step-box {
    width: 100%;
    height: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    font-weight: 500;

    .step {
      opacity: 0.3;
      cursor: pointer;
    }
    .step-active {
      cursor: pointer;
      opacity: 1;
    }
    @media screen and (max-width: 991px) {
      display: flex;
      flex-direction: row;
    }
    @media screen and (max-width: 767px) {
      font-size: 22px;
    }
    @media screen and (max-width: 435px) {
      width: 60%;
      margin: auto;
    }
  }

  .cart {
    width: 50px;
    height: 50px;
    background-color: #fff;
    border-radius: 50%;
    position: relative;
    margin-bottom: 50px;
    cursor: pointer;

    .icon {
      width: 100%;
      height: 100%;
      color: #3bb77e;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      font-size: 1.5rem;

      .bag-count {
        width: 20px;
        height: 20px;
        font-size: 0.8rem;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        background-color: #3bb77e;
        color: #fff;
        top: 5px;
        right: 5px;
      }
    }
    @media screen and (max-width: 991px) {
      margin-bottom: 0px;
      margin-right: 20px;
      width: 40px;
      height: 40px;
      .icon {
        .bag-count {
          top: 2px;
          right: 2px;
        }
      }
    }

    :hover {
      .hover-cart {
        display: block;
      }
    }
    .hover-cart {
      min-width: 350px;
      max-width: 400px;
      max-height: 500px;
      position: absolute;
      top: 0;
      left: 100%;
      border-radius: 10px;
      background-color: rgba(240, 240, 240, 0.7);
      z-index: 999;
      display: none;
      padding: 10px 15px;
      -webkit-box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);
      box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);
      overflow-y: auto;

      .cart-row {
        display: flex;
        flex-direction: column;
        word-break: keep-all;
        margin-bottom: 10px;
        color: #7e7e7e;
        background-color: #fff;
        border-radius: 10px;
        padding: 10px;

        .cart-tumbnail {
          display: flex;
          align-items: center;
          word-break: break-all;

          & img {
            max-width: 100px;
            max-height: 100px;
            padding: 10px;
            margin-right: 10px;
          }
          & h6 {
            color: #7e7e7e;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .cart-info {
          display: flex;
          justify-content: space-between;
          & span {
            margin-right: 10px;
          }
          .info-box {
            display: flex;
            flex-direction: column;
          }
          .btn-box {
            display: flex;
            align-items: flex-end;
            .btn-danger {
              padding: 5px 10px !important;
              background-color: #dc3545;
              :hover {
                border-color: #fd7e14;
                background-color: #fd7e14;
              }
            }
          }
        }
      }
      .cart-btn {
        width: 100%;
        display: flex;
        justify-content: center;
        & a {
          width: 80%;
          border-radius: 10px;
        }
      }
    }
  }
`;

export const CategorySection = styled.div`
  width: 90%;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (max-width: 991px) {
    width: 100%;
  }
`;

export const CategoryRow = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;

  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 460px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const SecondCategoryRow = styled.div`
  width: ${(props) => (props.length < 3 ? `80%` : "100%")};
  width: ${(props) => props.length < 3 && `70%`};
  width: ${(props) => props.length < 2 && `30%`};
  /* margin: 0 auto; */
  display: grid;
  grid-template-columns: ${(props) =>
    props.length < 3 ? `repeat(${props.length}, 1fr)` : "repeat(3, 1fr)"};
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }
  @media (max-width: 460px) {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }
`;

export const CategoryBox = styled.div`
  width: ${(props) => (props.second ? "100%" : "100%")};
  height: ${(props) => (props.second ? "17rem" : "17rem")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    props?.selected?.name === props.boxName
      ? "2px solid #3bb77e"
      : "2px solid #ececec"};
  border-radius: 10px;
  -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  padding: 10px;
  position: relative;
  cursor: pointer;
  background-color: white;

  .sublist {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    & li:not(:last-of-type) {
      margin-right: 5px;
    }
    & li:last-of-type {
      & span {
        display: none;
      }
    }
  }

  :hover {
    border: ${(props) =>
      props?.catSelect === props.boxId
        ? "2px solid #3bb77e"
        : "2px solid  #bce3c9"};
    /* & img {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);
      -webkit-transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);
    } */
  }
  :last-of-type {
    margin-right: 0;
    margin-bottom: 0;
  }

  & img {
    height: 60%;
    margin-bottom: 0.7rem;
  }

  & h6 {
    height: 10%;
    z-index: 5;
  }

  & ul {
    height: 10%;
  }

  @media (max-width: 767px) {
    height: 13rem;
    & h6 {
      font-size: 14px;
    }
    & span {
      font-size: 12px;
      word-break: keep-all;
      text-align: center;
    }
    & p {
      font-size: 13px;
    }
    & img {
      width: 6rem !important;
      height: 6rem !important;
    }
    :hover {
      border: ${(props) =>
        props?.catSelect === props.boxId
          ? "2px solid #3bb77e"
          : "2px solid  #bce3c9"};
      & img {
        transform: scale(1);
        -webkit-transform: scale(1);
        transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);
        -webkit-transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);
      }
    }
  }
`;

// secondStep
export const CheckboxDiv = styled.div`
  position: absolute;
  top: 0.3rem;
  right: 1rem;
  z-index: 20;
  & label {
    ::before {
      margin: 0 !important;
      display: flex !important;
      border: none !important;
    }
  }
`;

export const SelectedStepCommonInfo = styled.ul`
  width: 50%;
  word-break: keep-all;

  & h5 {
    margin-bottom: 20px;
  }

  & li {
    list-style-type: disc;
    margin-left: 20px;
    font-size: 1rem;
  }
`;

export const SelectedStepBtnWrapper = styled.div`
  width: 70%;
  display: flex;
  justify-content: end;
`;

// 컨텐츠 부분

export const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
`;

// 좌측 사이드 스티커
export const SideStickyWrapper = styled.div`
  width: 40%;
  height: fit-content;
  position: sticky;
  top: 150px;
  display: flex;
  margin-bottom: 20px;
  @media screen and (max-width: 991px) {
    .step_wrapper {
      display: none;
    }
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const StickyContents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SideImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  & img {
    min-width: 35%;
    max-width: 90%;
    text-align: center;
  }
  @media screen and (max-width: 767px) {
    width: 70%;
  }
`;

export const SideInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ececec;
    & a {
      border: none;
      background-color: #3bb77e;
      padding: 0 5px;
      color: #fff;
      border-radius: 5px;
      :hover {
        opacity: 0.8;
      }
    }
  }

  .title {
    font-size: 20px;
    font-weight: 400;
  }

  .ment {
    padding-left: 20px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ececec;
    & li {
      list-style: disc;
      font-size: 1rem;
      word-break: keep-all;
      margin-bottom: 5px;
    }
  }

  @media (max-width: 767px) {
    .title {
      font-size: 16px;
    }
    .ment {
      & li {
        font-size: 14px;
      }
    }
  }
  @media (max-width: 460px) {
    .ment {
      & li {
        font-size: 14px;
      }
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 60%;
  margin: 0 auto;
  border-left: 1px solid #ececec;
  padding-left: 2.5%;
  margin-left: 2.5%;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 767px) {
    border: none;
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;

export const ContentBox = styled.div`
  width: 100%;
  min-width: 10rem;
  margin-right: 1rem;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .size_info {
    display: flex;
    align-items: center;
    position: relative;
    height: fit-content;
    font-size: 14px;
    margin: auto 0 auto 10px;
    background-color: #3bb77e;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    :hover {
      opacity: 0.8;
    }
  }
  .cnt_box {
    width: 45%;
    display: flex;
    flex-direction: column;
    @media (max-width: 991px) {
      width: 100%;
    }
  }

  @media (max-width: 1200px) {
    width: 100%;
  }
  .radios {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: 3%;
    @media screen and (max-width: 460px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export const ContentBoxTitle = styled.h4`
  font-weight: 400;
  margin-bottom: 10px;
  display: flex;
  font-size: 20px;
`;

export const BoxItem = styled.div`
  width: 100%;
  display: ${(props) => (props.grid ? "grid" : "flex")};
  grid-template-columns: repeat(5, 1fr);
  column-gap: 10px;
  flex-direction: ${(props) => (props.row ? "row" : "column")};

  .print_download {
    background-color: #3e5379;
    color: white;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    :hover {
      opacity: 0.8;
    }
    width: 45%;
    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 991px) {
      width: 100%;
    }
  }
  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

export const BtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  margin-bottom: 20px;
  border-top: 1px solid #ececec;
  word-break: keep-all;

  & button:not(:last-of-type) {
    margin-right: 10px;
  }

  @media screen and (max-width: 460px) {
    flex-direction: column;
    & button {
      margin: 0 0px 10px 0 !important;
      width: 100%;
    }
  }
  .btn-secondary {
    :hover {
      border-color: #3bb77e;
    }
  }
`;

// 최하단 footer
export const FooterWrapper = styled.div`
  width: 100%;
  border-top: 1px solid #ececec;
  padding-top: 40px;
`;

export const FooterTableWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
  text-align: center;

  .custome-checkbox .form-check-label::before {
    margin: 0;
  }

  > div {
    display: flex;
    justify-content: end;
  }
`;

export const TableBtn = styled.button`
  background-color: #dc3545;

  :hover {
    background-color: #e66e61;
  }
`;

export const FooterBtnWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: end;
  margin-bottom: 30px;

  & button:not(:last-of-type) {
    margin-right: 10px;
  }

  .btn-secondary {
    :hover {
      border-color: #f1c40f;
      background-color: #f1c40f;
    }
  }
`;

// customizingSlider
export const CustomizingSliderSection = styled.section`
  width: 100%;
  display: flex;
`;

export const LeftBigBanner = styled.div`
  position: relative;
  width: calc((100% - 16px) / 4 * 3);
  :hover {
    .slider-arrow {
      opacity: 1;
      transition: 0.3s ease;
    }
  }
  .slider-arrow {
    opacity: 0;
    transition: 0.3s ease;
    width: calc(100% + 80px);
    left: -40px;
    top: 40%;
    & span {
      background-color: #fff;
      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);
      z-index: 10;
    }
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const LeftBigSlide = styled.div`
  cursor: pointer;

  & img {
    max-height: 350px;
  }
  & a {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const RightSmallBanner = styled.div`
  position: relative;
  width: calc((100% - 16px) / 4 * 1);
  margin-left: 16px;

  :hover {
    .slider-arrow {
      opacity: 1;
      transition: 0.3s ease;
    }
  }
  .slider-arrow {
    opacity: 0;
    transition: 0.3s ease;
    width: calc(100% + 80px);
    left: -40px;
    top: 40%;
    & span {
      background-color: #fff;
      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);
      z-index: 10;
    }
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const RightSmallSlide = styled.div`
  cursor: pointer;
  & img {
    max-height: 350px;
  }
  & a {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MobileBanner = styled.div`
  position: relative;
  display: none;
  width: 100%;
  :hover {
    .slider-arrow {
      opacity: 1;
      transition: 0.3s ease;
    }
  }
  .slider-arrow {
    opacity: 0;
    transition: 0.3s ease;
    width: calc(100% + 80px);
    left: -40px;
    top: 40%;
    & span {
      background-color: #fff;
      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);
      z-index: 10;
    }
  }
  @media screen and (max-width: 767px) {
    display: flex;
  }
`;

// 견적 바구니
export const CustomCartWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  background: #fff;
  box-shadow: ${(props) =>
    props.new ? "none" : " 1px 1px 10px 0px rgba(112, 112, 112, 0.25)"};
  margin-top: 20px;
  margin-bottom: ${(props) => (props.new ? "50px" : "20px")};
  padding: ${(props) => (props.new ? "none" : " 15px 20px")};
  & a {
    color: #7e7e7e;
    word-break: keep-all;
    font-size: 16px;
    :hover {
      color: #3bb77e;
    }
    @media screen and (max-width: 575px) {
      font-size: 13px;
    }
  }

  & h6 {
    cursor: pointer;
    :hover {
      border-bottom: 1px solid #7e7e7e;
    }
  }
  .cart {
    cursor: pointer;
    display: flex;
    position: relative;
    > span {
      white-space: nowrap;
      margin-right: 20px;
    }
    :hover {
      .hover-cart {
        display: block;
      }
    }
    .hover-cart {
      min-width: 350px;
      max-width: 400px;
      max-height: 500px;
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 10px;
      background-color: rgba(240, 240, 240, 0.7);
      z-index: 999;
      display: none;
      padding: 10px 15px;
      -webkit-box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);
      box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);
      overflow-y: auto;

      .cart-row {
        display: flex;
        flex-direction: column;
        word-break: keep-all;
        margin-bottom: 10px;
        color: #7e7e7e;
        background-color: #fff;
        border-radius: 10px;
        padding: 10px;

        .cart-tumbnail {
          display: flex;
          align-items: center;
          word-break: break-all;

          & img {
            max-width: 100px;
            max-height: 100px;
            padding: 10px;
            margin-right: 10px;
          }
          & h6 {
            color: #7e7e7e;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .cart-info {
          display: flex;
          justify-content: space-between;
          & span {
            margin-right: 10px;
          }
          .info-box {
            display: flex;
            flex-direction: column;
          }
          .btn-box {
            display: flex;
            align-items: flex-end;
            .btn-danger {
              padding: 5px 10px !important;
              background-color: #dc3545;
              :hover {
                border-color: #fd7e14;
                background-color: #fd7e14;
              }
            }
          }
        }
      }
      .cart-btn {
        width: 100%;
        display: flex;
        justify-content: center;
        & a {
          width: 80%;
          border-radius: 10px;
          color: #fff;
        }
      }
    }
  }

  .icon {
    color: #3bb77e;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 1.5rem;
    .bag-count {
      width: 20px;
      height: 20px;
      font-size: 0.8rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      background-color: #3bb77e;
      color: #fff;
      top: -8px;
      right: -8px;
    }
  }
  @media screen and (max-width: 767px) {
    .cart {
      > span {
        display: none;
      }
    }
  }
`;

// customizingCate
export const CustomizingCateSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;

export const TypeWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
`;

export const TypeBtn = styled.button`
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border-radius: 10px;
  background-color: ${(props) => (props.categoryType ? "#3bb77e" : "#f1f1f1")};

  .title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: normal;
    text-align: start;
    word-break: keep-all;
    color: ${(props) => (props.categoryType ? "#fff" : "#565656")};
    & span {
      font-size: 14px;
    }
    & h6 {
      font-size: 20px;
      font-weight: 600;
      font-style: normal;
      text-align: start;
      color: ${(props) => (props.categoryType ? "#fff" : "#565656")};
    }
  }
  .icon {
    font-size: 40px;
    line-height: normal;
    color: ${(props) => (props.categoryType ? "#fff" : "#565656")};
    & i {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  @media screen and (max-width: 991px) {
    padding: 20px 20px;
    .title {
      & span {
        font-size: 12px;
      }
      & h6 {
        font-size: 18px;
      }
    }
    .icon {
      font-size: 2rem;
    }
  }
  @media screen and (max-width: 767px) {
    padding: 20px;
    .title {
      & span {
        font-size: 10px;
      }
      & h6 {
        font-size: 16px;
      }
    }
    .icon {
      font-size: 28px;
    }
  }
  @media screen and (max-width: 575px) {
    padding: 20px;
    .title {
      & span {
        display: none;
      }
      & h6 {
        font-size: 14px;
      }
    }
    .icon {
      font-size: 28px;
    }
  }
`;

export const CategoryWrapper = styled.div`
  width: 100%;
  position: relative;
  border-radius: 10px;
  background: #fff;
  box-shadow: 1px 1px 10px 0px rgba(112, 112, 112, 0.25);
  display: flex;
  justify-content: flex-start;
  padding: 20px;
  margin-bottom: 20px;
  .cateSwiper {
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: 767px) {
    overflow-x: hidden;

    .cateSwiper {
      width: 100%;
      margin-left: 0px;
      overflow: visible;
      .swiper-wrapper {
        width: 100%;
      }
      .swiper-slide {
        margin-right: 15px !important;
      }
    }
  }
  @media screen and (max-width: 320px) {
    .cateSwiper {
      .swiper-slide {
        min-width: 52px;
        margin-right: 15px !important;
      }
    }
  }
`;

export const CateBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  word-break: keep-all;
  text-align: center;
  & span {
    margin-top: 5px;
    line-height: normal;
    white-space: nowrap;
  }
  & figure {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    border-radius: 20px;
    background-color: #f4f4f4;
    padding: 10px;
    border: ${(props) => (props.active ? "3px solid #3bb77e" : "none")};
  }
  & img {
    width: 100%;
  }
  :hover {
    & span {
      color: #3bb77e;
    }
  }
  @media screen and (min-width: 1200px) {
    & figure {
      width: 115px;
      height: 115px;
    }
  }
  @media screen and (max-width: 767px) {
    & figure {
      min-width: 52px;
      min-height: 52px;
      border-radius: 5px;
      margin-bottom: 0px;
      padding: 5px;
    }
    & span {
      font-size: 11px;
    }
  }
`;
export const SlideArrows = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 50%;
  left: -25px;
  width: calc(100% + 50px);

  & span {
    position: absolute;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);
    background-color: #fff;
    color: #5a5a5a;
    font-size: 19px;
    cursor: pointer;
    z-index: 9;
    transition: all 0.1s ease 0s !important;
    :hover {
      background-color: #3bb77e;
      color: #fff;
    }
  }
  .custom_next_fct {
    right: 0;
  }
  .custom_next_sct {
    right: 0;
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

// 제작사례 & 포장재리뷰
export const PortFolioSliderSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const SliderWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
`;

export const SliderTitle = styled.div`
  grid-column: 2 span / 2 span;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  word-break: keep-all;
  height: 226px;
  margin-right: 25px;
  & h5 {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1.8rem;
    line-height: 1.5;
  }
  .more {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    border: none;
    border-radius: 1000px;
    background: #3bb77e;
    color: #fff;
    padding: 10px 20px;
    line-height: normal;
    & i {
      margin-left: 10px;
      margin-top: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    :hover {
      opacity: 0.8;
    }
  }
  .mobile {
    display: none;
  }
  @media screen and (max-width: 991px) {
    .more {
      font-size: 14px;
      padding: 10px 20px;
      white-space: nowrap;
    }
  }
  @media screen and (max-width: 767px) {
    grid-column: 3 span / 3 span;
    margin-right: 10px;
    .more {
      font-size: 12px;
      padding: 10px 20px;
      white-space: normal;
    }
  }
  @media screen and (max-width: 575px) {
    grid-column: 10 span / 10 span;
    height: fit-content;
    margin-bottom: 20px;
    & h5 {
      display: none;
    }
    .more {
      display: none;
    }
    .mobile {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }
  }
`;

export const Slider = styled.div`
  grid-column: 8 span / 8 span;
  width: 100%;
  display: flex;
  position: relative;
  .swiper {
    width: 100%;
    height: 100%;
    padding-bottom: 50px;
  }
  .swiper-scrollbar-horizontal {
    height: 2px;
    width: calc(100% - 100px);
    left: 0;
    bottom: 14px;
    background: rgba(59, 183, 126, 0.45);
  }
  .swiper-scrollbar-drag {
    background-color: #3bb77e;
  }

  @media screen and (max-width: 767px) {
    grid-column: 7 span / 7 span;

    .swiper-scrollbar-horizontal {
      width: calc(100% - 80px);
    }
    .swiper-pagination-fraction {
      font-size: 12px;
    }
  }
  @media screen and (max-width: 575px) {
    grid-column: 10 span / 10 span;
    overflow: hidden;
    justify-content: start;
    .swiper {
      overflow: visible;
      width: 100%;
      margin-left: 0px;
      padding-bottom: 0px;
    }
    .swiper-slide {
      min-width: 133px;
      max-width: 133px;
      margin-right: 20px !important;
    }
    .swiper-scrollbar-horizontal {
      display: none;
    }
  }
`;

export const PortfolioBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
  & figure {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    overflow: hidden;
  }
  @media screen and (max-width: 575px) {
    & figure {
      width: 133px;
      height: 133px;
    }
  }
`;

export const PortfolioSliderArrows = styled.div`
  left: calc(100% - 100px);
  width: 100px;
  bottom: -7px;
  padding: 0px 5px;
  position: absolute;
  display: grid;
  align-items: center;
  justify-content: flex-end;
  grid-template-columns: repeat(2, 1fr);
  gap: 7px;
  font-size: 24px;
  z-index: 30;
  & span {
    cursor: pointer;
    color: #3bb77e;
    border: 1px solid #3bb77e;
    border-radius: 10000px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    & i {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    :hover {
      color: #fff;
      background-color: #3bb77e;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 20px;
    left: calc(100% - 70px);
    width: 70px;
    bottom: 0px;
    gap: 5px;
    & span {
      width: 30px;
      height: 30px;
    }
  }
  @media screen and (max-width: 575px) {
    display: none;
  }
`;

// 맞춤제작 세부
export const CustomNewSection = styled.section`
  @media screen and (max-width: 575px) {
    .cateWrapper {
      display: none;
    }
  }
`;

export const CustomMobileTitle = styled.div`
  width: 100%;
  display: none;
  margin: 30px 0px 10px 0px;
  @media screen and (max-width: 575px) {
    display: flex;
  }
`;
